import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { fileUrl } from "@/lib/api";
import { Sparkles, Leaf, ChefHat } from "lucide-react";

const Badges = ({ d }) => (
  <div className="flex flex-wrap gap-1.5 mt-1">
    {d.specialita && <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-full bg-bordeaux/10 text-bordeaux"><Sparkles className="w-3 h-3" />Specialità Masetti</span>}
    {d.fatto_in_casa && <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-full bg-brass/15 text-brass-hover"><ChefHat className="w-3 h-3" />Fatto in casa</span>}
    {d.stagionale && <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-full bg-green-700/10 text-green-800"><Leaf className="w-3 h-3" />Stagionale</span>}
  </div>
);

export default function DishCard({ d, autoOpen = false }) {
  const [open, setOpen] = useState(autoOpen);
  useEffect(() => { if (autoOpen) setOpen(true); }, [autoOpen]);
  const img = fileUrl(d.image);
  return (
    <>
      <div onClick={() => setOpen(true)} data-testid={`dish-${d.id}`}
        className="group bg-white rounded-xl border border-brass/15 overflow-hidden hover:shadow-lg hover:border-brass/40 transition-all cursor-pointer flex flex-col">
        {img && (
          <div className="h-44 overflow-hidden">
            <img src={img} alt={d.image_alt || d.nome} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          </div>
        )}
        <div className="p-4 flex-1 flex flex-col">
          <div className="flex justify-between items-start gap-3">
            <h3 className="font-serif text-lg text-oak leading-tight">{d.nome}</h3>
            {d.prezzo && <span className="font-serif text-lg text-bordeaux whitespace-nowrap">€ {d.prezzo}</span>}
          </div>
          {d.descrizione && <p className="font-accent italic text-base text-oak/70 mt-1 leading-snug">{d.descrizione}</p>}
          <Badges d={d} />
          {d.allergeni && <p className="text-[11px] text-oak/50 mt-2">Allergeni: {d.allergeni}</p>}
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md bg-cream border-brass/30 p-0 overflow-hidden max-h-[90vh] overflow-y-auto">
          <DialogTitle className="sr-only">{d.nome}</DialogTitle>
          {img && <img src={img} alt={d.image_alt || d.nome} className="w-full h-56 object-cover" />}
          <div className="p-6">
            <div className="flex justify-between items-start gap-3">
              <h3 className="font-serif text-2xl text-bordeaux">{d.nome}</h3>
              {d.prezzo && <span className="font-serif text-xl text-bordeaux">€ {d.prezzo}</span>}
            </div>
            {d.descrizione && <p className="font-accent italic text-lg text-oak/80 mt-2">{d.descrizione}</p>}
            <Badges d={d} />
            {d.allergeni && <p className="text-sm text-oak/60 mt-3">Allergeni: {d.allergeni}</p>}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
